import { Link } from 'react-router-dom';
import { manhwaList } from '@/mocks/manhwa';

export default function UpdateSection() {
  const updates = manhwaList.slice(0, 3);
  const spotlight = manhwaList[4];

  return (
    <section className="py-16 md:py-20 bg-background-100/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-10">
          <div>
            <p className="text-xs font-medium tracking-widest text-accent-600 mb-2">本周新更</p>
            <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">最近更新与编辑推荐</h2>
            <p className="mt-3 text-foreground-600 text-sm md:text-base">跟进最新连载，每周编辑推荐不容错过的韩漫。</p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          <div className="lg:col-span-5">
            <Link
              to={`/detail/${spotlight.id}`}
              className="group block bg-background-50 border border-background-200 rounded-3xl overflow-hidden hover:border-primary-300 transition-colors"
            >
              <div className="aspect-[16/9] overflow-hidden">
                <img
                  src={spotlight.cover}
                  alt={`${spotlight.title}韩漫封面`}
                  title={`${spotlight.title} - 编辑精选推荐`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 md:p-6">
                <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
                  <i className="ri-fire-line" aria-hidden="true"></i>
                  本周编辑推荐
                </span>
                <h3 className="font-heading text-xl md:text-2xl text-foreground-950">{spotlight.title}</h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-3">{spotlight.summary}</p>
                <span className="mt-4 inline-flex items-center gap-1.5 text-sm text-primary-600">
                  立即查看 <i className="ri-arrow-right-line" aria-hidden="true"></i>
                </span>
              </div>
            </Link>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
            {updates.map((m) => (
              <Link
                key={m.id}
                to={`/detail/${m.id}`}
                className="group bg-background-50 border border-background-200 rounded-2xl overflow-hidden hover:border-primary-300 transition-colors"
              >
                <div className="aspect-[3/4] overflow-hidden">
                  <img
                    src={m.cover}
                    alt={`${m.title}韩漫封面`}
                    title={`${m.title} - 本周更新`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-4">
                  <h3 className="font-medium text-foreground-950 text-sm truncate whitespace-nowrap">{m.title}</h3>
                  <p className="mt-1.5 text-xs text-foreground-500">更新至第 {m.chapters} 话</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}